
import { Injectable } from '@angular/core';

import { environment } from 'environments/environment';
import { from } from 'rxjs';

import { CredencialUsuario, RespuestaAutenticacion, RespuestaAutenticacionExterno } from '@interfaces/index';
import { UserInfoExterno } from '@/rituals/interfaces/user-info-externo.interface';
import { PersonalizacionUser } from '@interfaces/personalizacion-user.interface';

@Injectable({
  providedIn: 'root'
})
export class SeguridadService {

  constructor() { }

  apiURL = environment.apiURL + '/cuentas';
  private readonly llaveToken ='token';
  private readonly llaveExpiracion = 'token-expiracion';
  private readonly campoRol = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

  estaLogueado():boolean{

    const token = localStorage.getItem(this.llaveToken);

    if(!token){
      return false;
    }

    const expiracion:any = localStorage.getItem(this.llaveExpiracion);
    const expiracionFecha = new Date(expiracion);
    if(expiracionFecha <= new Date()){
      this.logout();
      return false;
    }
    return true;
  }

  logout(){
    localStorage.setItem('dark','false');
    localStorage.removeItem(this.llaveToken);
    localStorage.removeItem(this.llaveExpiracion);
    localStorage.removeItem('cliente');
    localStorage.removeItem('negocio');
    localStorage.removeItem("colorPrincipal");
    localStorage.removeItem("colorSecundario");
    localStorage.removeItem("colorTextoPrincipal");
    localStorage.removeItem("colorTextoSecundario");
    localStorage.removeItem("fondoRituals");
  }

  obtenerRol(): string{
    return this.obtnerCampoJWT(this.campoRol);
  }

  obtenerCliente(): string{
    return this.obtnerCampoJWT('cliente');
  }

  obtenerNegocio(): string | null{
    return localStorage.getItem('negocio');
  }

  obtenerNombreCompleto(): string{
    return this.obtnerCampoJWT('mombreFull');
  }

  obtenerUsuario(): string{
    return this.obtnerCampoJWT('unique_name');
  }

  ObtenerPersonalizacion():PersonalizacionUser{
    return {
      colorPrincipal: localStorage.getItem('colorPrincipal')!,
      colorSecundario: localStorage.getItem('colorSecundario')!,
      colorTextoPrincipal: localStorage.getItem('colorTextoPrincipal')!,
      colorTextoSecundario: localStorage.getItem('colorTextoSecundario')!,
      fondoRituals: localStorage.getItem('fondoRituals')!,
      colorFondo: localStorage.getItem('colorFondo')!,
      transparenciaFondo:Number(localStorage.getItem('transparenciaFondo')!),
      transparenciaPrincipal:Number(localStorage.getItem('transparenciaPrincipal')!),
      transparenciaSecundario:Number(localStorage.getItem('transparenciaSecundario')!),
    }
  }

  obtnerCampoJWT(campo: string): string{
    const token = localStorage.getItem(this.llaveToken);
    if(!token){return '';}
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    var dataToken = JSON.parse(jsonPayload);
    return dataToken[campo];
  }

  login(credenciales: CredencialUsuario){

    const login = async(credenciales: CredencialUsuario) => {

      const resp = await fetch(this.apiURL + '/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credenciales)
      });

      if(!resp.ok) throw new Error('No se pudo logro iniciar sesión');

      const data = await resp.json() as RespuestaAutenticacion;

      return data;
    }

    return from(login(credenciales));
  }

  guardarToken(respuestaAutenticacion: RespuestaAutenticacion, negocio:string){
    localStorage.setItem('dark', 'false');
    localStorage.setItem(this.llaveToken, respuestaAutenticacion.token);
    localStorage.setItem(this.llaveExpiracion,respuestaAutenticacion.expiracion.toString());
    localStorage.setItem("cliente", this.obtenerCliente());
    localStorage.setItem("negocio", negocio);
  }

  guardarTokenExterno(respuestaAutenticacion: RespuestaAutenticacionExterno, negocio:string){
    localStorage.setItem('dark', 'false');
    localStorage.setItem(this.llaveToken, respuestaAutenticacion.token);
    localStorage.setItem(this.llaveExpiracion,respuestaAutenticacion.expiracion.toString());
    localStorage.setItem("cliente", this.obtenerCliente());
    localStorage.setItem("colorPrincipal", respuestaAutenticacion.colorPrincipal);
    localStorage.setItem("colorSecundario", respuestaAutenticacion.colorSecundario);
    localStorage.setItem("colorTextoPrincipal", respuestaAutenticacion.colorTextoPrincipal);
    localStorage.setItem("colorTextoSecundario", respuestaAutenticacion.colorTextoSecundario);
    localStorage.setItem("fondoRituals", respuestaAutenticacion.fondoRituals);
    localStorage.setItem("colorFondo", respuestaAutenticacion.colorFondo);
    localStorage.setItem("transparenciaFondo", respuestaAutenticacion.transparenciaFondo.toString());
    localStorage.setItem("transparenciaPrincipal", respuestaAutenticacion.transparenciaPrincipal.toString());
    localStorage.setItem("transparenciaSecundario", respuestaAutenticacion.transparenciaSecundario.toString());
    localStorage.setItem("negocio", negocio);
  }

  obtenerToken(): any{
    return localStorage.getItem(this.llaveToken);
  }

  loginExterno(usuario: UserInfoExterno){

    const login = async(usuario: UserInfoExterno) => {

      const resp = await fetch(this.apiURL + '/externo', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(usuario)
      });

      if(!resp.ok) throw new Error('No se pudo logro iniciar sesión');

      const data = await resp.json() as RespuestaAutenticacionExterno;

      return data;
    }

    return from(login(usuario));
  }
}
